import { render, staticRenderFns } from "./lingxing.vue?vue&type=template&id=5e0394b4&scoped=true&"
import script from "./lingxing.vue?vue&type=script&lang=js&"
export * from "./lingxing.vue?vue&type=script&lang=js&"
import style0 from "./lingxing.vue?vue&type=style&index=0&id=5e0394b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0394b4",
  null
  
)

export default component.exports